module.exports = __webpack_public_path__ + "static/img/xiazailuxiang.c049818.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/xiazailuxiang.png
// module id = nFkq
// module chunks = 24